/* eslint-disable react/jsx-props-no-spreading */
import NiceModal, { useModal, antdModalV5 } from '@ebay/nice-modal-react';
import Modal from 'Components/Modal';
import Text from 'Components/Text';
import ModalFooter from 'Components/ModalFooter';
import { Flex, Image, Button } from 'antd';
import PharmacyImg from 'Assets/images/pharmacy.svg';

interface IProps {
  clinicName: string;
}

const NoPharmacyModal = NiceModal.create<IProps>(({ clinicName }) => {
  const modal = useModal();

  return (
    <Modal {...antdModalV5(modal)} title="Issue Prescription" width={720}>
      <Flex vertical align="center" justify="center" gap={32}>
        <Image src={PharmacyImg} alt="pharmacy" preview={false} />
        <Text>There is no pharmacy to issue from clinic {clinicName}</Text>
      </Flex>
      <ModalFooter>
        <Flex gap={16}>
          <Button onClick={() => modal.hide()}>Close</Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
});

export default NoPharmacyModal;
